import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import courseActions from '@redux/course/actions';
import { RootState } from '@redux/reducer';

const { fetchCourseReviewSummaryAction } = courseActions;

type UseCourseReviewSummaryProps = {
  idName?: string;
};

export const useCourseReviewSummary = ({ idName }: UseCourseReviewSummaryProps) => {
  const dispatch = useDispatch();

  const { courseReviewSummaryState } = useSelector((state: RootState) => ({
    courseReviewSummaryState: state.Course.get('courseReviewSummaryState'),
  }));

  const handleResetCourseReviewSummary = () => {
    dispatch(fetchCourseReviewSummaryAction.reset());
  };

  const handleFetchCourseReviewSummary = useCallback(() => {
    if (!idName) {
      return;
    }
    dispatch(
      fetchCourseReviewSummaryAction.request({
        courseIdOrIdName: idName,
      }),
    );
  }, [dispatch, idName]);

  const {
    data: courseReviewSummaryData,
    error: courseReviewSummaryDataError,
    isLoading: isCourseReviewSummaryDataLoading,
    isError: isCourseReviewSummaryDataError,
    isSuccess: isCourseReviewSummaryDataSuccess,
  } = courseReviewSummaryState;

  const averageRatingTotal = useMemo(() => {
    if (!courseReviewSummaryData) {
      return 0;
    }
    return courseReviewSummaryData.averageRating.toFixed(1);
  }, [courseReviewSummaryData]);

  return {
    handleFetchCourseReviewSummary,
    courseReviewSummaryData,
    courseReviewSummaryDataError,
    isCourseReviewSummaryDataLoading,
    isCourseReviewSummaryDataError,
    isCourseReviewSummaryDataSuccess,
    averageRatingTotal,
    handleResetCourseReviewSummary,
  };
};
